<template>
  <div>
    <span class="titleTOP">账号登录</span>
    <div class="divAccount">
      <img src="../../../assets/img/account.png" class="icon">
      <input ref="username" type="text" value="" class="username" autocomplete="off" :placeholder="'请输入账号'">
    </div>
    <div class="divMima">
      <img src="../../../assets/img/password.png" class="icon">
      <input ref="password" type="password" value="" class="pwd" autocomplete="off" :placeholder="'请输入密码'">
    </div>
    <!-- <div class="divCode" v-if="loginType">
      <img src="../../assets/img/code.png" class="icon">
      <input ref="code" value="" class="pwd code" :placeholder="'请输入验证码'">
    </div>
    <ErCode ref="ercode" :visible="loginType" @refresh="getNewCode" />
    <MoveBar ref="movebar"   v-if="moveBarshow" @on-change="moveChange"/> -->

    <div class="divToggle" v-if="loginType">
      <span class="sanjiao" >
        <img src="../../../assets/img/phone.png" class="toggle phone" @click="toggles">
      </span>
    </div>

  </div>
</template>

<script>
  // import i18n from '../../assets/js/i18n'
  import ErCode from "./components/ErCode";
  import MoveBar from "../Login/MoveBar.vue";

  export default {
    name: 'AccountLogin',
    components: { ErCode ,MoveBar},
    props: {
      loginType: {
        type: Boolean,
        default: false
      },
      TypeToggle: {
        type: Number,
        default: 1
      },
    },
    data() {
      return {
        key: '',
        moveBarshow:window.ProjectConfig &&  window.ProjectConfig.moveBar,
        verifyBar:false  // 滑动条
      }
    },
    beforeCreate() {
      // this.$t = i18n.t.bind(i18n)
    },
    methods: {
      login() {
        this.$parent.login()
      },
      toggles() {
        this.$emit('toggle', 2)
      },
      getNewCode(obj) {
        const { key } = obj;
        this.key = key
      },
      moveChange(val){
        // 滑动条
        this.verifyBar = val
      }
    }
  }

</script>
